import type { ExpiringItemView, RecipeSuggestion } from "../types/dashboard";
import { downloadRecipe } from "../utils/downloadRecipe";
import { createIcon } from "../utils/icons";
import { formatIngredientExpiryLabel, getIngredientExpiryStatus } from "../utils/recipeIngredients";
import { closeAnimatedSheet, mountAnimatedSheet } from "../utils/sheetAnimation";

export function openRecipeSheet(recipe: RecipeSuggestion, expiringItems: ExpiringItemView[]): void {
    const overlay = document.createElement("div");
    overlay.className = "sheet-overlay";

    const sheet = document.createElement("div");
    sheet.className = "recipe-sheet";

    const header = document.createElement("div");
    header.className = "recipe-sheet-header";

    const title = document.createElement("h2");
    title.className = "recipe-sheet-title";
    title.textContent = recipe.dish;

    const closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.className = "recipe-sheet-dismiss";
    closeBtn.setAttribute("aria-label", "Close");
    closeBtn.appendChild(createIcon("close", "icon-sm"));
    closeBtn.addEventListener("click", () => closeAnimatedSheet(overlay));

    header.appendChild(title);
    header.appendChild(closeBtn);

    const summary = document.createElement("p");
    summary.className = "recipe-sheet-summary";
    summary.textContent = recipe.summary;

    const ingredientsTitle = document.createElement("h3");
    ingredientsTitle.className = "recipe-sheet-ingredients-title";
    ingredientsTitle.textContent = "Ingredients";

    const ingredientsList = document.createElement("div");
    ingredientsList.className = "recipe-sheet-ingredient-list";
    for (const ing of recipe.ingredients) {
        const chip = document.createElement("span");
        chip.className = "recipe-sheet-ingredient-chip";
        const expiryStatus = getIngredientExpiryStatus(ing, expiringItems);
        if (expiryStatus === "expired") {
            chip.classList.add("recipe-sheet-ingredient-chip--expired");
        } else if (expiryStatus === "expiring") {
            chip.classList.add("recipe-sheet-ingredient-chip--expiring");
        }
        chip.textContent = formatIngredientExpiryLabel(ing, expiringItems);
        ingredientsList.appendChild(chip);
    }

    const stepsTitle = document.createElement("h3");
    stepsTitle.className = "recipe-sheet-steps-title";
    stepsTitle.textContent = "Steps";

    const stepsList = document.createElement("ol");
    stepsList.className = "recipe-sheet-steps";
    for (const step of recipe.steps) {
        const li = document.createElement("li");
        li.textContent = step;
        stepsList.appendChild(li);
    }

    const downloadBtn = document.createElement("button");
    downloadBtn.type = "button";
    downloadBtn.className = "recipe-sheet-download";
    downloadBtn.appendChild(createIcon("download", "icon-sm"));
    downloadBtn.append(" Download Recipe");
    downloadBtn.addEventListener("click", () => {
        void downloadRecipe(recipe, expiringItems);
    });

    sheet.appendChild(header);
    sheet.appendChild(summary);
    sheet.appendChild(ingredientsTitle);
    sheet.appendChild(ingredientsList);
    sheet.appendChild(stepsTitle);
    sheet.appendChild(stepsList);
    sheet.appendChild(downloadBtn);
    overlay.appendChild(sheet);

    overlay.addEventListener("click", (e) => {
        if (e.target === overlay) closeAnimatedSheet(overlay);
    });

    mountAnimatedSheet(overlay);
}
